import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();
  const handleGoHome = () => {
    navigate("/");
  };
  return (
    <div className="z-10 flex items-center justify-center flex-col w-full text-white bg-black/70 text-center p-8">
      <h1 className="text-xl mb-4">404 - Page Not Found</h1>
      <p className="text-lg mb-6">
        Sorry, the page you are looking for does not exist.
      </p>
      <button
        onClick={handleGoHome}
        className="px-4 py-2 text-sm bg-indigo-500 hover:bg-indigo-600 cursor-pointer rounded-lg"
      >
        Go to Home Page
      </button>
    </div>
  );
};

export default NotFound;
